import signPage from "./sign.router";
export default [
    {
        path: "/",
        name: "home",
        component: (resolve) => require(["@/views/mobileView/Home.vue"], resolve),
        redirect: "index",
        children: [
            {
                path: "index",
                name: "Home",
                meta: {
                    rootPage: true,
                },
                component: (resolve) => require(["@/views/mobileView/home/index.vue"], resolve),
            },
            {
                path: "scholar-service",
                name: "ScholarService",
                meta: {
                    rootPage: true,
                },
                component: (resolve) => require(["@/views/mobileView/ScholarService"], resolve),
            },
            {
                path: "partner-service",
                name: "PartnerService",
                meta: {
                    rootPage: true,
                },
                component: (resolve) => require(["@/views/mobileView/Partner"], resolve),
            },
            {
                path: "My",
                name: "My",
                meta: {
                    rootPage: true,
                },
                component: (resolve) => require(["@/views/mobileView/My"], resolve),
            },
        ],
    },
    ...signPage,
    // 合伙人页面
    {
        path: "/partner",
        name: "Partner",
        component: (resolve) => require(["@/views/mobileView/Partner/ServicePage"], resolve),
        children: [
            // 合伙人签约信息页面
            {
                path: "form-service",
                name: "PartnerServiceForm",
                meta: {
                    title: "知识合伙人入驻",
                },
                component: (resolve) =>
                    require(["@/views/mobileView/Partner/ServicePage/formPage.vue"], resolve),
            },
            // 合伙人协议页面
            {
                path: "partner-agreement",
                name: "PartnerAgreementPage",
                meta: {
                    title: "知识合伙人入驻协议",
                },
                component: (resolve) =>
                    require(["@/views/mobileView/Partner/ServicePage/agreementPage.vue"], resolve),
            },
            // 合伙人申请结果页面
            {
                path: "partner-result",
                name: "PartnerResult",
                meta: {
                    title: "知识合伙人入驻",
                },
                component: (resolve) =>
                    require(["@/views/mobileView/Partner/ServicePage/resultPage.vue"], resolve),
            },
            // 合伙人权益申请页面
            {
                path: "partner-equity",
                name: "PartnerEquity",
                meta: {
                    title: "",
                },
                beforeEnter: (to, from, next) => {
                    to.meta.title = to.query.title;
                    next();
                },
                component: (resolve) =>
                    require(["@/views/mobileView/Partner/ServicePage/equityFormPage.vue"], resolve),
            },
            // 合伙人权益申请结果页面
            {
                path: "equity-result",
                name: "EquityResult",
                meta: {
                    title: "",
                },
                beforeEnter: (to, from, next) => {
                    to.meta.title = to.query.title;
                    next();
                },
                component: (resolve) =>
                    require(["@/views/mobileView/Partner/ServicePage/equityResult.vue"], resolve),
            },
            // 合伙人权益官网搭建申请页面
            {
                path: "partner-equity-website",
                name: "PartnerEquityWebsite",
                meta: {
                    title: "官网搭建",
                },
                component: (resolve) =>
                    require(["@/views/mobileView/Partner/ServicePage/equityWebsite.vue"], resolve),
            },
            // 合伙人权益官网搭建申请结果页面
            {
                path: "equity-website-result",
                name: "EquityWebsiteResult",
                meta: {
                    title: "官网搭建",
                },
                component: (resolve) =>
                    require([
                        "@/views/mobileView/Partner/ServicePage/equityWebsiteResult.vue",
                    ], resolve),
            },
        ],
    },
    // 合伙人权益官网搭建上传页面
    {
        path: "/upload-page",
        name: "UploadPage",
        component: (resolve) =>
            require(["@/views/mobileView/Partner/ServicePage/uploadPage.vue"], resolve),
    },
    // 自助签约选择页面
    {
        path: "/select-service",
        name: "SelectService",
        meta: {
            title: "自助签约",
        },
        component: (resolve) =>
            require(["@/views/mobileView/ServiceSign/SelectService.vue"], resolve),
    },
    // 自助签约页面
    {
        path: "/service-sign",
        name: "ServiceSign",
        component: (resolve) => require(["@/views/mobileView/ServiceSign"], resolve),
        redirect: "/service-sign/form-service",
        children: [
            // 自助签约商户信息页面
            {
                path: "form-service",
                name: "FormService",
                meta: {
                    title: "",
                },
                beforeEnter: (to, from, next) => {
                    if (to.query.type == 2) {
                        to.meta.title = "合伙人收款商户Ⅰ";
                    } else {
                        to.meta.title = "合伙人收款商户Ⅱ";
                    }
                    next();
                },
                component: (resolve) =>
                    require(["@/views/mobileView/ServiceSign/FormService.vue"], resolve),
            },
            // 自助签约对公验证页面
            {
                path: "public-verification",
                name: "PublicVerification",
                meta: {
                    title: "对公验证",
                    canToAgain: true,
                },
                component: (resolve) =>
                    require(["@/views/mobileView/ServiceSign/PublicVerification.vue"], resolve),
            },
            // 自助签约签约协议页面
            {
                path: "agreement-sign",
                name: "AgreementSign",
                meta: {
                    title: "签约协议",
                    canToAgain: true,
                },
                component: (resolve) =>
                    require(["@/views/mobileView/ServiceSign/AgreementSign.vue"], resolve),
            },
            // 自助签约签约结果页面
            {
                path: "sign-result",
                name: "SignResult",
                meta: {
                    title: "签约结果",
                },
                component: (resolve) =>
                    require(["@/views/mobileView/ServiceSign/SignResult.vue"], resolve),
            },
        ],
    },
    // 推广页面
    {
        path: "/extend",
        name: "Extend",
        component: (resolve) => require(["@/views/mobileView/extend"], resolve),
        redirect: "/extend/my-extend",
        children: [
            // 我的推广列表
            {
                path: "my-extend",
                name: "MyExtend",
                meta: {
                    title: "推广商品",
                    toExtend: true,
                },
                component: (resolve) =>
                    require(["@/views/mobileView/extend/MyExtendList.vue"], resolve),
            },
            // 推广市场页面
            {
                path: "extend-market",
                name: "ExtendMarket",
                meta: {
                    title: "推广市场",
                    KeepAlive: true,
                },
                component: (resolve) =>
                    require(["@/views/mobileView/extend/ExtendMarket.vue"], resolve),
            },
            // 推广商品详情页页面
            {
                path: "extend-detail",
                name: "ExtendDetail",
                meta: {
                    title: "推广商品详情",
                },
                component: (resolve) =>
                    require(["@/views/mobileView/extend/ExtendDetail.vue"], resolve),
            },
            // 推广申请页面
            {
                path: "no-extend",
                name: "NoExtend",
                meta: {
                    title: "分享推广",
                },
                component: (resolve) =>
                    require(["@/views/mobileView/extend/NoAuthority.vue"], resolve),
            },
            // 推广关闭页面
            {
                path: "close-extend",
                name: "ExtendClose",
                meta: {
                    title: "推广商品",
                },
                component: (resolve) =>
                    require(["@/views/mobileView/extend/ExtendClose.vue"], resolve),
            },
            // 推广开通成功页面
            {
                path: "open-extend",
                name: "ExtendOpen",
                meta: {
                    title: "分享推广",
                },
                component: (resolve) =>
                    require(["@/views/mobileView/extend/ExtendOpen.vue"], resolve),
            },
            // 推广协议页面
            {
                path: "agreement-extend",
                name: "ExtendAgreement",
                meta: {
                    title: "推广用户协议",
                },
                component: (resolve) =>
                    require(["@/views/mobileView/extend/ExtendAgreement.vue"], resolve),
            },
        ],
    },

    // 我的/我的订单
    {
        path: "/orders",
        name: "orders",
        component: (resolve) => require(["@/views/mobileView/My/orders/orders"], resolve),
    },
    // 退换/售后
    {
        path: "/aftermarket",
        name: "aftermarket",
        component: (resolve) => require(["@/views/mobileView/My/aftermarket/aftermarket"], resolve),
    },
    // 退换/售后 详情
    {
        path: "/aftermarketInfo",
        name: "aftermarketInfo",
        component: (resolve) =>
            require(["@/views/mobileView/My/aftermarket/aftermarketInfo"], resolve),
    },
    // 售后进度
    {
        path: "/aftermarketSchedule",
        name: "AftermarketSchedule",
        component: (resolve) =>
            require(["@/views/mobileView/My/aftermarket/aftermarketSchedule"], resolve),
    },
    // 退货详情
    {
        path: "/materialFlow",
        name: "MaterialFlow",
        component: (resolve) =>
            require(["@/views/mobileView/My/aftermarket/materialFlow"], resolve),
    },
    // 选择售后类型
    {
        path: "/selectAfterSalesType",
        name: "selectAfterSalesType",
        component: (resolve) =>
            require(["@/views/mobileView/My/selectAfterSalesType/selectAfterSalesType"], resolve),
    },
    {
        path: "/refundRebate",
        name: "refundRebate",
        component: (resolve) =>
            require(["@/views/mobileView/My/selectAfterSalesType/refundRebate"], resolve),
    },
    // 评价
    {
        path: "/assessmentCenter",
        name: "assessmentCenter",
        component: (resolve) =>
            require(["@/views/mobileView/My/assessmentCenter/assessmentCenter"], resolve),
    },
    // 我的/我的订单/订单详情
    {
        path: "/orderDetails",
        name: "tobepaid",
        component: (resolve) => require(["@/views/mobileView/My/orders/tobepaid"], resolve),
    },
    // 我的订单-查看发票页面
    {
        path: "/check-invoice",
        name: "CheckInvoice",
        component: (resolve) => require(["@/views/mobileView/My/orders/CheckInvoice"], resolve),
    },
    // 物流状态
    {
        path: "/logisticsStatus",
        name: "logisticsStatus",
        component: (resolve) => require(["@/views/mobileView/My/orders/logisticsStatus"], resolve),
    },
    // 开局发票或退换售后
    {
        path: "/afterSale",
        name: "afterSaleOrInvoice",
        component: (resolve) => require(["@/views/mobileView/My/orders/AfterSales"], resolve),
    },

    // 我的页里客服页面
    {
        path: "/customer-service",
        name: "customerService",
        component: (resolve) => require(["@/views/mobileView/My/customerService"], resolve),
    },
    //  我的/我的订单/订单详情/查看参会人
    {
        path: "/memberInfoInOrder",
        name: "meetingMemberInOrder",
        component: (resolve) =>
            require(["@/views/mobileView/My/orders/meetingMemberInOrder"], resolve),
    },
    // 我的页里收藏页
    {
        path: "/collect",
        name: "collect",
        component: (resolve) => require(["@/views/mobileView/My/collect/collect"], resolve),
    },
    // 我的页里书架页
    {
        path: "/bookshelf",
        name: "bookshelf",
        component: (resolve) => require(["@/views/mobileView/My/Bookshelf/index.vue"], resolve),
    },
    // 我的页里课程页
    {
        path: "/mycourse",
        name: "mycourse",
        component: (resolve) => require(["@/views/mobileView/My/mycourse"], resolve),
    },
    // 我的页里会议页
    {
        path: "/mymeeting",
        name: "mymeeting",
        component: (resolve) => require(["@/views/mobileView/My/mymeeting/mymeeting"], resolve),
    },
    // 我的页里-我的会议-会议稿件
    {
        path: "/mymeeting-edit",
        name: "mymeetingEdit",
        component: (resolve) => require(["@/views/mobileView/My/mymeeting/eidtDetail"], resolve),
    },
    // 我的页里会议页里我报名的里详情页
    {
        path: "/registration",
        name: "registration",
        component: (resolve) => require(["@/views/mobileView/My/mymeeting/registration"], resolve),
    },
    {
        //登录页
        path: "/logins",
        name: "logins",
        meta: {
            pageTitle: "登录",
        },
        component: (resolve) => require(["@/views/mobileView/My/login/logins"], resolve),
    },
    {
        //验证码页
        path: "/getcode",
        name: "getcode",
        meta: {
            pageTitle: "获取验证码",
        },
        component: (resolve) => require(["@/views/mobileView/My/login/getcode"], resolve),
    },
    {
        //密码页
        path: "/Password",
        name: "Password",
        meta: {
            pageTitle: "登录",
        },
        component: (resolve) => require(["@/views/mobileView/My/login/Password"], resolve),
    },
    {
        //忘记密码页
        path: "/forget",
        name: "forget",
        meta: {
            pageTitle: "忘记密码",
        },
        component: (resolve) => require(["@/views/mobileView/My/login/forget"], resolve),
    },
    {
        //忘记密码页中获取验证码页，按钮不一样，所以从新插入。
        path: "/getCodes",
        name: "getCodes",
        meta: {
            pageTitle: "获取验证码",
        },
        component: (resolve) => require(["@/views/mobileView/My/login/getCodes"], resolve),
    },
    {
        //忘记密码页中设置密码页。
        path: "/nextStep",
        name: "nextStep",
        meta: {
            pageTitle: "设置新密码",
        },
        component: (resolve) => require(["@/views/mobileView/My/login/nextStep"], resolve),
    },
    // 我的页里设置页
    {
        path: "/setup",
        name: "setup",
        component: (resolve) => require(["@/views/mobileView/My/setup/setup"], resolve),
    },
    // 我的页里设置页账号与安全页
    {
        path: "/security",
        name: "security",
        component: (resolve) => require(["@/views/mobileView/My/setup/security"], resolve),
    },
    // 我的页里设置页账号与安全页手机号页
    {
        path: "/replacephone",
        name: "replacephone",
        component: (resolve) => require(["@/views/mobileView/My/setup/replacephone"], resolve),
    },
    // 我的页里设置页账号与安全页验证码页
    {
        path: "/code",
        name: "code",
        component: (resolve) => require(["@/views/mobileView/My/setup/code"], resolve),
    },
    // 我的页里设置页账号与安全页设置密码页
    {
        path: "/setpassword",
        name: "setpassword",
        component: (resolve) => require(["@/views/mobileView/My/setup/setpassword"], resolve),
    },
    // 我的页里设置页账号与安全页设置登录密码页
    {
        path: "/setlong",
        name: "setlong",
        component: (resolve) => require(["@/views/mobileView/My/setup/setlong"], resolve),
    },
    // 我的页里设置页账号与安全页修改密码页
    {
        path: "/changepassword",
        name: "changepassword",
        component: (resolve) => require(["@/views/mobileView/My/setup/changepassword"], resolve),
    },
    // 我的页里设置页账号与安全页注销页
    {
        path: "/logoff",
        name: "logoff",
        component: (resolve) => require(["@/views/mobileView/My/setup/logoff"], resolve),
    },
    // 我的页里设置页账号与安全页注销页获取验证码
    {
        path: "/logoffCode",
        name: "logoffCode",
        component: (resolve) => require(["@/views/mobileView/My/setup/logoffCode"], resolve),
    },
    // 我的页里设置页账号与安全页无法注销页
    {
        path: "/nologoff",
        name: "nologoff",
        component: (resolve) => require(["@/views/mobileView/My/setup/nologoff"], resolve),
    },
    // 我的页里设置页发票编辑页
    {
        path: "/invoice",
        name: "Invoice",
        component: (resolve) => require(["@/views/mobileView/My/setup/invoice"], resolve),
    },
    // 我的页里设置页收货地址页
    {
        path: "/address",
        name: "Address",
        component: (resolve) => require(["@/views/mobileView/My/setup/address"], resolve),
    },
    // 我的页里设置页收货地址页新增收货页
    {
        path: "/newaddress",
        name: "newaddress",
        component: (resolve) => require(["@/views/mobileView/My/setup/newaddress"], resolve),
    },
    // 我的页里设置页收货地址页编辑收货页
    {
        path: "/editaddress",
        name: "editaddress",
        component: (resolve) => require(["@/views/mobileView/My/setup/editaddress"], resolve),
    },
    // 我的页里设置页建议与反馈页
    {
        path: "/feedback",
        name: "feedback",
        component: (resolve) => require(["@/views/mobileView/My/setup/feedback"], resolve),
    },
    // 我的页里消息页
    {
        path: "/message",
        name: "message",
        component: (resolve) => require(["@/views/mobileView/My/message/message"], resolve),
    },
    // 我的页里消息页里公告
    {
        path: "/Notice",
        name: "Notice",
        component: (resolve) => require(["@/views/mobileView/My/message/Notice"], resolve),
    },
    // 我的页里消息页里通知
    {
        path: "/tell",
        name: "tell",
        component: (resolve) => require(["@/views/mobileView/My/message/tell"], resolve),
    },
    // 我的页里消息页里通知里详情页
    {
        path: "/details",
        name: "details",
        component: (resolve) => require(["@/views/mobileView/My/message/details"], resolve),
    },
    // 我的页里消息页里公告里详情页
    {
        path: "/noticeDetails",
        name: "noticeDetails",
        component: (resolve) => require(["@/views/mobileView/My/message/noticeDetails"], resolve),
    },

    // 我的页里普通用户认证页
    {
        path: "/authentication",
        name: "authentication",
        component: (resolve) =>
            require(["@/views/mobileView/My/authentication/authentication"], resolve),
    },

    // 我的页面学者认证页面
    {
        path: "/scholar",
        name: "scholarAuthentication",
        component: (resolve) => require(["@/views/mobileView/My/information/scholar"], resolve),
    },
    // 我的页面期刊认证页面
    {
        path: "/periodical-authentication",
        name: "periodicalAuthentication",
        component: (resolve) => require(["@/views/mobileView/My/information/periodical"], resolve),
    },
    // 我的页面机构认证页面
    {
        path: "/organization-authentication",
        name: "organizationAuthentication",
        component: (resolve) =>
            require(["@/views/mobileView/My/information/organization"], resolve),
    },
    // 认证页面跳转输入input类型页面
    {
        path: "/inputEdit",
        name: "InputEdit",
        component: (resolve) => require(["@/views/mobileView/My/information/inputEdit"], resolve),
    },
    {
        path: "/periodical-edit",
        name: "periodicalEdit",
        component: (resolve) =>
            require(["@/views/mobileView/My/information/periodicalEdit"], resolve),
    },
    // 认证页面跳转上传图片类型页面
    {
        path: "/imgEdit",
        name: "ImgEdit",
        component: (resolve) => require(["@/views/mobileView/My/information/imgEdit"], resolve),
    },
    // 我的页普通用户提交认证未通过
    {
        path: "/scholarFail",
        name: "scholarFail",
        component: (resolve) =>
            require(["@/views/mobileView/My/authentication/scholarFail"], resolve),
    },
    // 我的页普通用户提交认证 认证状态页
    {
        path: "/scholarStatus",
        name: "scholarStatus",
        component: (resolve) =>
            require(["@/views/mobileView/My/authentication/scholarStatus"], resolve),
    },
    // 未认证跳转添加职称
    {
        path: "/Atitle",
        name: "Atitle",
        component: (resolve) => require(["@/views/mobileView/My/authentication/Atitle"], resolve),
    },
    // 未认证跳转删除职称
    {
        path: "/Adeletetitle",
        name: "Adeletetitle",
        component: (resolve) =>
            require(["@/views/mobileView/My/authentication/Adeletetitle"], resolve),
    },
    // 未认证跳转添加学科领域
    {
        path: "/Aarea",
        name: "Aarea",
        component: (resolve) => require(["@/views/mobileView/My/authentication/Aarea"], resolve),
    },
    // 未认证跳转删除学科领域
    {
        path: "/Adeletearea",
        name: "Adeletearea",
        component: (resolve) =>
            require(["@/views/mobileView/My/authentication/Adeletearea"], resolve),
    },
    // 未认证跳转研究方向
    {
        path: "/Astudy",
        name: "Astudy",
        component: (resolve) => require(["@/views/mobileView/My/authentication/Astudy"], resolve),
    },
    // 未认证跳转添加任职机构
    {
        path: "/Abeoffice",
        name: "Abeoffice",
        component: (resolve) =>
            require(["@/views/mobileView/My/authentication/Abeoffice"], resolve),
    },
    // 未认证跳转删除任职机构
    {
        path: "/Adeletebe",
        name: "Adeletebe",
        component: (resolve) =>
            require(["@/views/mobileView/My/authentication/Adeletebe"], resolve),
    },
    // 我的页里已认证机构跳转基本信息页
    {
        path: "/institution-modification",
        name: "InstitutionModification",
        component: (resolve) =>
            require(["@/views/mobileView/My/institution/InstitutionModification"], resolve),
    },
    // 我的页里已认证期刊跳转基本信息页
    {
        path: "/periodical-modification",
        name: "PeriodicalModification",
        meta: {
            KeepAlive: true,
        },
        component: (resolve) =>
            require(["@/views/mobileView/My/periodical/PeriodicalModification"], resolve),
    },
    // 我的页里已认证学者跳转基本信息页
    {
        path: "/information",
        name: "information",
        component: (resolve) => require(["@/views/mobileView/My/information/information"], resolve),
    },
    // 我的页里已认证页学者认证填写姓名页
    {
        path: "/noPass",
        name: "NoPass",
        component: (resolve) => require(["@/views/mobileView/My/information/noPass"], resolve),
    },
    // 我的页里已认证页学者认证填写姓名页
    {
        path: "/fullname",
        name: "fullname",
        component: (resolve) => require(["@/views/mobileView/My/information/fullname"], resolve),
    },
    // 我的页里已认证学者跳转基本信息页民族页
    {
        path: "/nation",
        name: "nation",
        component: (resolve) => require(["@/views/mobileView/My/information/nation"], resolve),
    },
    // 我的页里已认证学者跳转基本信息页毕业院校页
    {
        path: "/school",
        name: "school",
        component: (resolve) => require(["@/views/mobileView/My/information/school"], resolve),
    },
    // 我的页里已认证学者认证页学者认证添加职称页
    {
        path: "/title",
        name: "title",
        component: (resolve) => require(["@/views/mobileView/My/information/title"], resolve),
    },
    // 我的页里已认证学者认证页学者认证页修改职称页
    {
        path: "/deletetitle",
        name: "deletetitle",
        component: (resolve) => require(["@/views/mobileView/My/information/deletetitle"], resolve),
    },
    // 我的页里已认证学者认证页学者认证页添加科学领域页
    {
        path: "/area",
        name: "area",
        component: (resolve) => require(["@/views/mobileView/My/information/area"], resolve),
    },
    // 我的页里已认证学者认证页学者认证页修改科学领域页
    {
        path: "/deletearea",
        name: "deletearea",
        component: (resolve) => require(["@/views/mobileView/My/information/deletearea"], resolve),
    },
    // 我的页里已认证学者认证页学者认证页研究方向页
    {
        path: "/study",
        name: "study",
        component: (resolve) => require(["@/views/mobileView/My/information/study"], resolve),
    },
    // 我的页里已认证学者认证页学者认证页任职机构页
    {
        path: "/beoffice",
        name: "beoffice",
        component: (resolve) => require(["@/views/mobileView/My/information/beoffice"], resolve),
    },
    // 我的页里已认证学者认证页学者认证页修改任职机构页
    {
        path: "/deletebe",
        name: "deletebe",
        component: (resolve) => require(["@/views/mobileView/My/information/deletebe"], resolve),
    },
    // 我的页里已认证学者跳转基本信息页添加原任职机构页
    {
        path: "/beforeOffice",
        name: "beforeOffice",
        component: (resolve) =>
            require(["@/views/mobileView/My/information/beforeOffice"], resolve),
    },
    // 我的页里已认证学者认证页学者认证页修改原任职机构页
    // 我的页里普通用户认证页学者认证页修改原任职机构页
    {
        path: "/deletebeOffice",
        name: "deletebeOffice",
        component: (resolve) =>
            require(["@/views/mobileView/My/information/deletebeOffice"], resolve),
    },
    // 我的页里已认证学者跳转基本信息页个人简历页
    {
        path: "/PersonalProfile",
        name: "PersonalProfile",
        component: (resolve) =>
            require(["@/views/mobileView/My/information/PersonalProfile"], resolve),
    },
    // 我的页里已认证学者跳转基本信息页教育背景页
    {
        path: "/education",
        name: "education",
        component: (resolve) => require(["@/views/mobileView/My/information/education"], resolve),
    },
    // 我的页里已认证学者跳转基本信息页教育背景页不通过原因页
    {
        path: "/educationPages",
        name: "educationPages",
        component: (resolve) =>
            require(["@/views/mobileView/My/information/educationPages"], resolve),
    },
    // 我的页里已认证学者跳转基本信息页工作经历页
    {
        path: "/work",
        name: "work",
        component: (resolve) => require(["@/views/mobileView/My/information/work"], resolve),
    },
    // 我的页里已认证学者跳转基本信息页社会任职页
    {
        path: "/society",
        name: "society",
        component: (resolve) => require(["@/views/mobileView/My/information/society"], resolve),
    },
    // 我的页里已认证学者跳转基本信息页职称经历页
    {
        path: "/experience",
        name: "experience",
        component: (resolve) => require(["@/views/mobileView/My/information/experience"], resolve),
    },
    // 我的页里已认证学者跳转基本信息页获奖情况页
    {
        path: "/Awards",
        name: "Awards",
        component: (resolve) => require(["@/views/mobileView/My/information/Awards"], resolve),
    },
    // 支付页面
    {
        path: "/payment",
        name: "payment",
        component: (resolve) => require(["@/views/mobileView/payment/payment"], resolve),
    },

    {
        // 学术资讯列表页
        path: "/academicInformation",
        name: "AcademicInformation",
        meta: {
            title: "学术资讯",
            KeepAlive: true,
        },
        component: (resolve) => require(["@/views/mobileView/List/XszxList.vue"], resolve),
    },
    {
        // 学术论文列表页
        path: "/academicPaper",
        name: "AcademicPaper",
        meta: {
            title: "学术论文",
            KeepAlive: true,
        },
        component: (resolve) => require(["@/views/mobileView/List/XslvList.vue"], resolve),
    },
    {
        // 学术专著列表页
        path: "/academicMonograph",
        name: "AcademicMonograph",
        meta: {
            title: "学术专著",
            KeepAlive: true,
        },
        component: (resolve) => require(["@/views/mobileView/List/XszzList.vue"], resolve),
    },
    {
        // 教育培训列表页
        path: "/educationalTraining",
        name: "EducationalTraining",
        meta: {
            title: "教育培训",
        },
        component: (resolve) => require(["@/views/mobileView/List/JypxList.vue"], resolve),
    },
    {
        // 学术会议列表页
        path: "/academicConference",
        name: "AcademicConference",
        meta: {
            title: "学术会议",
            KeepAlive: true,
        },
        component: (resolve) => require(["@/views/mobileView/List/XshyList.vue"], resolve),
    },
    {
        // 商品会议列表页
        path: "/attendConference",
        name: "AttendConference",
        meta: {
            title: "学术会议",
            KeepAlive: true,
        },
        component: (resolve) => require(["@/views/mobileView/List/SphyList.vue"], resolve),
    },
    {
        // 商品会议列表页
        path: "/bookMall",
        name: "BookMall",
        meta: {
            title: "图书商城",
            KeepAlive: true,
        },
        component: (resolve) => require(["@/views/mobileView/List/TsscList.vue"], resolve),
    },
    {
        // 选刊投稿列表页
        path: "/manuscript",
        name: "Manuscript",
        meta: {
            title: "选刊投稿",
        },
        component: (resolve) => require(["@/views/mobileView/List/Manuscript.vue"], resolve),
    },
    {
        // 行业报告列表页
        path: "/industryReport",
        name: "IndustryReport",
        meta: {
            title: "行业报告",
            KeepAlive: true,
        },
        component: (resolve) => require(["@/views/mobileView/List/Report.vue"], resolve),
    },
    {
        // 百家在线列表页
        path: "/scholarOnline",
        name: "ScholarOnline",
        meta: {
            title: "百家在线",
            KeepAlive: true,
        },
        component: (resolve) => require(["@/views/mobileView/List/BjzxList.vue"], resolve),
    },
    {
        // 百家在线列表页
        path: "/periodicalOnline",
        name: "PeriodicalOnline",
        meta: {
            title: "百科在线",
            KeepAlive: true,
        },
        component: (resolve) => require(["@/views/mobileView/List/BkzxList.vue"], resolve),
    },
    {
        // 百家号
        path: "/appusesbaijia",
        name: "appusesbaijia",
        meta: {
            title: "百家号",
        },
        component: (resolve) => require(["@/views/mobileView/detail/baijiaDetail.vue"], resolve),
    },
    {
        // 百科号
        path: "/appusesbaike",
        name: "appusesbaike",
        meta: {
            title: "百科号",
        },
        component: (resolve) => require(["@/views/mobileView/detail/baikeDetail.vue"], resolve),
    },
    {
        // 机构号
        path: "/appusesjigou",
        name: "AppusesJiGou",
        meta: {
            title: "机构号",
            // KeepAlive: true,
        },
        component: (resolve) => require(["@/views/mobileView/detail/jigouDetail.vue"], resolve),
    },

    {
        // 搜索中间页
        path: "/search",
        name: "Search",
        meta: {
            title: "搜索中间页",
            rootPage: true,
        },
        component: (resolve) => require(["@/views/mobileView/search"], resolve),
    },
    {
        // 搜索结果页
        path: "/searchResult",
        name: "SearchResult",
        meta: {
            KeepAlive: true,
        },
        component: (resolve) => require(["@/views/mobileView/search/searchResult"], resolve),
    },
    {
        // 资讯详情页
        path: "/msgDetails",
        name: "msgDetails",
        meta: {
            title: "资讯详情",
        },
        component: (resolve) => require(["@/views/mobileView/detail/information.vue"], resolve),
    },
    {
        // 论文详情页
        path: "/thesisDetail",
        name: "thesisDetail",
        meta: {
            title: "论文详情页",
        },
        component: (resolve) => require(["@/views/mobileView/detail/paper.vue"], resolve),
    },
    {
        // 论文商品确认订单页
        path: "/paperConfirmOrder",
        name: "PaperConfirmOrder",
        meta: {
            title: "论文商品确认订单页",
        },
        component: (resolve) =>
            require(["@/views/mobileView/ConfirmOrderPage/paperConfirmOrder.vue"], resolve),
    },
    {
        // 名录详情页
        path: "/appusesinstitutions",
        name: "appusesinstitutions",
        meta: {
            title: "名录详情页",
        },
        component: (resolve) => require(["@/views/mobileView/detail/institutions.vue"], resolve),
    },
    {
        // 学术会议详情页
        path: "/meetingDetails",
        name: "meetingDetails",
        meta: {
            title: "会议详情页",
        },
        component: (resolve) =>
            // require(["@/views/mobileView/detail/meetingLetter.vue"], resolve),
            require(["@/views/mobileView/Details/meetingDetails/index.vue"], resolve),
    },
    {
        // 会议论文集
        path: "/conferenceProceedings",
        name: "conferenceProceedings",
        meta: {
            title: "会议论文集",
        },
        component: (resolve) =>
            require(["@/views/mobileView/Details/conferenceProceedings/index.vue"], resolve),
    },
    // 会议报名页面
    {
        path: "/fillPaticipantInfo",
        name: "fillPaticipantInfo",
        meta: {
            title: "会议报名页",
        },
        component: (resolve) =>
            require(["@/views/mobileView/Details/meetingDetails/fillParticipantInfo.vue"], resolve),
    },
    // 会议确认订单页
    {
        // 课程商品确认订单页
        path: "/meetingConfirmOrder",
        name: "meetingOrdeyPay",
        meta: {
            title: "课程商品确认订单页",
        },
        component: (resolve) =>
            require(["@/views/mobileView/ConfirmOrderPage/meetingConfirmOrder.vue"], resolve),
    },

    {
        // 课程商品详情页
        path: "/courseDetails",
        name: "courseDetails",
        meta: {
            title: "课程商品详情页",
        },
        component: (resolve) =>
            require(["@/views/mobileView/Details/courseDetails/courseDetails.vue"], resolve),
    },
    {
        // 课程商品确认订单页
        path: "/CourseConfirmOrder",
        name: "CourseConfirmOrder",
        meta: {
            title: "课程商品确认订单页",
        },
        component: (resolve) =>
            require(["@/views/mobileView/ConfirmOrderPage/CourseConfirmOrder.vue"], resolve),
    },
    {
        // 图书商品详情页
        path: "/bookDetails",
        name: "bookDetails",
        meta: {
            title: "图书商品详情页",
        },
        component: (resolve) =>
            require(["@/views/mobileView/Details/bookDetails/BookDetails.vue"], resolve),
    },
    {
        // 图书商品确认订单页
        path: "/bookConfirmOrder",
        name: "bookConfirmOrder",
        meta: {
            title: "图书商品确认订单页",
        },
        component: (resolve) =>
            require(["@/views/mobileView/ConfirmOrderPage/bookConfirmOrder.vue"], resolve),
    },
    {
        // 万商数据详情页
        path: "/detail/report",
        name: "ReportDetails",
        meta: {
            title: "万商数据详情页",
        },
        component: (resolve) =>
            require(["@/views/mobileView/Details/reportDetails/index.vue"], resolve),
    },
    {
        // 图书商品确认订单页
        path: "/reportConfirmOrder",
        name: "ReportConfirmOrder",
        meta: {
            title: "万商数据商品确认订单页",
        },
        component: (resolve) =>
            require(["@/views/mobileView/ConfirmOrderPage/reportConfirmOrder.vue"], resolve),
    },
    {
        // 专著详情页
        path: "/concentrationDetails",
        name: "concentrationDetails",
        meta: {
            title: "专著详情",
        },
        component: (resolve) => require(["@/views/mobileView/detail/monograph.vue"], resolve),
    },

    {
        // 隐私政策
        path: "/mPAgreement",
        name: "mPAgreement",
        meta: {
            title: "隐私协议",
        },
        component: (resolve) => require(["@/views/mobileView/mPAgreement/index.vue"], resolve),
    },
    {
        // 征稿函详情页
        path: "/solicitationDetails",
        name: "solicitationDetails",
        meta: {
            title: "征稿函详情",
        },
        component: (resolve) => require(["@/views/mobileView/detail/draftLetter.vue"], resolve),
    },
    {
        // 视频详情页
        path: "/video",
        name: "video",
        meta: {
            title: "视频详情",
        },
        component: (resolve) => require(["@/views/mobileView/detail/video.vue"], resolve),
    },
    {
        // 行业报告详情页
        path: "/dataDetails",
        name: "dataDetails",
        meta: {
            title: "行业报告详情",
        },
        component: (resolve) => require(["@/views/mobileView/detail/industry.vue"], resolve),
    },
    {
        // 杂志社详情页
        path: "/magazine",
        name: "magazine",
        meta: {
            title: "杂志社详情",
        },
        component: (resolve) => require(["@/views/mobileView/directory/magazine.vue"], resolve),
    },
    {
        // 协会详情页
        path: "/association",
        name: "association",
        meta: {
            title: "协会详情",
        },
        component: (resolve) => require(["@/views/mobileView/directory/association.vue"], resolve),
    },
    {
        // 政府详情页
        path: "/government",
        name: "government",
        meta: {
            title: "政府详情",
        },
        component: (resolve) => require(["@/views/mobileView/directory/government.vue"], resolve),
    },
    {
        // 院校详情页
        path: "/university",
        name: "university",
        meta: {
            title: "院校详情",
        },
        component: (resolve) => require(["@/views/mobileView/directory/university.vue"], resolve),
    },
    {
        // 其它详情页
        path: "/other",
        name: "other",
        meta: {
            title: "其它详情",
        },
        component: (resolve) => require(["@/views/mobileView/directory/other.vue"], resolve),
    },
    {
        // 百家号详细信息
        path: "/baijiaDetail",
        name: "baijia",
        meta: {
            title: "百家号详细信息",
        },
        component: (resolve) => require(["@/views/mobileView/detail-info/baijia.vue"], resolve),
    },
    {
        // 百科号详细信息
        path: "/baikeDetail",
        name: "baike",
        meta: {
            title: "百家号详细信息",
        },
        component: (resolve) => require(["@/views/mobileView/detail-info/baike.vue"], resolve),
    },
    {
        // 百科号详细信息
        path: "/institutionsJournal",
        name: "institutionsJournal",
        meta: {
            title: "机构期刊列表",
        },
        component: (resolve) => require(["@/views/mobileView/detail-info/journal.vue"], resolve),
    },
    {
        // 百科号详细信息
        path: "/institutionsMeeting",
        name: "institutionsMeeting",
        meta: {
            title: "机构会议列表",
        },
        component: (resolve) => require(["@/views/mobileView/detail-info/meeting.vue"], resolve),
    },
    {
        // 百科号详细信息
        path: "/institutionsScholars",
        name: "institutionsScholars",
        meta: {
            title: "机构学者列表",
        },
        component: (resolve) => require(["@/views/mobileView/detail-info/scholars.vue"], resolve),
    },
    {
        // 在线阅读
        path: "/read",
        name: "read",
        meta: {
            title: "征稿函详情",
        },
        component: (resolve) => require(["@/views/mobileView/detail/Read.vue"], resolve),
    },
    {
        // 学者库
        path: "/academiclibraries",
        name: "academiclibraries",
        component: (resolve) =>
            require(["@/views/mobileView/home/homePageFeatures/academicLibraries"], resolve),
    },
    {
        // 期刊服务
        path: "/periodicalService",
        name: "periodicalService",
        component: (resolve) =>
            require(["@/views/mobileView/home/homePageFeatures/periodicalService"], resolve),
    },
    {
        // 百家百科列表
        path: "/baijiabaike",
        name: "baijiabaike",
        component: (resolve) =>
            require(["@/views/mobileView/home/homePageFeatures/baijiabaikeList"], resolve),
    },
    {
        // 期刊推广
        path: "/JournalOfPromotion",
        name: "JournalOfPromotion",
        component: (resolve) =>
            require([
                "@/views/mobileView/home/homePageFeatures/periodicalService/detail/JournalOfPromotion.vue",
            ], resolve),
    },
    {
        // 跳转用户使用协议
        path: "/apptcp",
        name: "apptcp",
        component: (resolve) => require(["@/views/mobileView/jump/jumuserprotocol.vue"], resolve),
    },
    {
        // 注销协议
        path: "/applogouttcp",
        name: "applogouttcp",
        component: (resolve) => require(["@/views/mobileView/jump/jumpuseslogout.vue"], resolve),
    },
    {
        // 词典详情页
        path: "/dictionaryDetail/:searchStr/:out",
        name: "dictionaryDetail",
        meta: {
            title: "词典详情",
        },
        component: (resolve) =>
            require(["@/views/mobileView/detail/dictionaryDetail.vue"], resolve),
    },
    {
        // 期刊简介
        path: "/perDetail",
        name: "perDetail",
        meta: {
            title: "期刊简介",
        },
        component: (resolve) => require(["@/views/mobileView/perDetail"], resolve),
    },
    {
        // 征稿启事
        path: "/collectionArticle",
        name: "collectionArticle",
        meta: {
            title: "征稿启事",
        },
        component: (resolve) => require(["@/views/mobileView/collectionArticle"], resolve),
    },
    {
        // 跳转百家中间页
        path: "/jumpbaijia",
        name: "jumpbaijia",
        meta: {
            title: "跳转百家",
        },
        component: (resolve) => require(["@/views/mobileView/jump/jumpbaijia.vue"], resolve),
    },
    {
        // 跳转百科中间页
        path: "/jumpbaike",
        name: "jumpbaike",
        meta: {
            title: "跳转百科",
        },
        component: (resolve) => require(["@/views/mobileView/jump/jumpbaike.vue"], resolve),
    },
    {
        // 跳转下载应用
        path: "/jumpdownload",
        name: "jumpdownload",
        meta: {
            title: "跳转下载应用",
        },
        component: (resolve) => require(["@/views/mobileView/jump/jumpdownload.vue"], resolve),
        beforeEnter: (to, from, next) => {
            // pc页面扫码进入直接下载
            var u = navigator.userAgent;
            var isWeixin = u.toLowerCase().indexOf("micromessenger") !== -1; // 微信内
            var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (to.query.version) {
                if (isAndroid) {
                    if (isWeixin) {
                        window.location.href =
                            "https://a.app.qq.com/o/simple.jsp?pkgname=com.china.knowledgemesh";
                    } else {
                        window.location.href = `https://zwi.cnknowledge.com/android/中文知识网_${to.query.version}.apk`;
                    }
                } else if (isIOS) {
                    window.location.href =
                        "https://apps.apple.com/us/app/%E4%B8%AD%E6%96%87%E7%9F%A5%E8%AF%86%E7%BD%91/id1618139452";
                }
            } else {
                next();
            }
        },
    },
    {
        // 跳转下载应用
        path: "/login",
        name: "login",
        meta: {
            title: "登录",
        },
        component: (resolve) => require(["@/views/mobileView/jump/jumpLogin.vue"], resolve),
    },
    {
        // 跳转下载应用
        path: "/forgetPas",
        name: "forgetPas",
        meta: {
            title: "注册",
        },
        component: (resolve) => require(["@/views/mobileView/jump/jumpForgetPas.vue"], resolve),
    },
    {
        // 跳转会议图片详情页
        path: "/jumpmeetingImages",
        name: "jumpmeetingImages",
        component: (resolve) => require(["@/views/mobileView/jump/jumpmeetingImages.vue"], resolve),
    },
    {
        // 跳转会议图片详情页
        path: "/openReading",
        name: "openReading",
        component: (resolve) => require(["@/views/mobileView/jump/openReading.vue"], resolve),
    },

    {
        // 跳转稿件详情
        path: "/articleProgress",
        name: "articleprogress",
        component: (resolve) =>
            require(["@/views/mobileView/ScholarService/articleProgress.vue"], resolve),
    },
    {
        path: "/:catchAll(.*)",
        name: "not-found",
        component: (resolve) => require(["@/views/PCView/notFound.vue"], resolve),
    },
];
